import * as types from './mutation-types'
import Vue from 'vue'
import axios from 'axios'
import { MutationTree } from 'vuex/types'
import { IAuthState } from './state'
import { resetState } from '@/store'
import { calculSecurityRights } from '@/enum/SecurityItems'
import { windows } from '@hscmap/vue-window'
import { i18n } from '@/locale/vueI18n'

const mutations: MutationTree<IAuthState> = {
  [types.AUTH_REQUEST]: state => {
    state.authStatus = 'AuthenticationProgress'
  },
  [types.AUTH_SUCCESS]: state => {
    //on s'assure que le state est résété pour le nouvel utilisateur connecté
    resetState()
    state.authStatus = 'AuthenticationSuccess'
  },
  [types.AUTH_ERROR]: (state, message) => {
    state.authStatus = message || i18n.t('Login.AuthenticationError').toString()
  },
  [types.AUTH_CHANGEPASSWORD_REQUEST]: state => {
    state.changePwdStatus = i18n.t('ChangePassword.ChangePasswordProgress').toString()
  },
  [types.AUTH_CHANGEPASSWORD_SUCCESS]: state => {
    state.changePwdStatus = i18n.t('ChangePassword.ChangePasswordSuccess').toString()
  },
  [types.AUTH_CHANGEPASSWORD_ERROR]: (state, message) => {
    state.changePwdStatus = message || i18n.t('ChangePassword.ChangePasswordError').toString()
  },
  [types.AUTH_CHANGEPASSWORD_RESET_STATUS]: state => {
    state.changePwdStatus = ''
  },
  [types.AUTH_LOGOUT]: state => {
    localStorage.removeItem('user-token')
    state.token = ''
    state.authStatus = ''
    delete axios.defaults.headers.common['authorization']
    Vue.nextTick(() => {
      resetState()
    })
  },
  [types.AUTH_USER_REQUEST]: state => {
    state.userStatus = 'loading'
  },
  [types.AUTH_USER_SUCCESS]: (state, { userProfile, wsUrl, token }) => {
    state.wsUrl = wsUrl
    state.userStatus = 'success'
    axios.defaults.headers.common['authorization'] = token
    localStorage.setItem('user-token', token)
    state.token = token
    state.userProfile = userProfile
    state.userSecurity = calculSecurityRights(state.userProfile.roles)
  },
  [types.AUTH_USER_ERROR]: state => {
    state.userStatus = 'error'
  },
  [types.AUTH_AUTO_RENEW]: (state, renewTokenId) => {
    state.renewTokenId = renewTokenId
  },
  [types.AUTH_RESET_STATUS]: state => {
    state.authStatus = ''
  },
  [types.AUTH_PASSWORD_REQUEST]: state => {
    state.authStatus = i18n.t('Login.PassForgottenProgress').toString()
  },
  [types.AUTH_PASSWORD_SUCCESS]: state => {
    state.authStatus = i18n.t('Login.PassForgottenSuccess').toString()
  },
  [types.AUTH_PASSWORD_ERROR]: (state, message) => {
    state.authStatus = message || i18n.t('Login.PassForgottenError').toString()
  },
  [types.AUTH_CREATE_PASSWORD_REQUEST]: state => {
    state.authStatus = i18n.t('CreatePassword.CreatePasswordProgress').toString()
  },
  [types.AUTH_CREATE_PASSWORD_SUCCESS]: state => {
    state.authStatus = i18n.t('CreatePassword.CreatePasswordSuccess').toString()
  },
  [types.AUTH_CREATE_PASSWORD_ERROR]: (state, message) => {
    state.authStatus = message || i18n.t('CreatePassword.CreatePasswordError').toString()
  },
}

export default mutations
